<template lang="pug">
  main
    NavBarInventario
    ModalDocumentosArt(v-show="modalStatusD" :tipo="tipoFileUp" :articulo="itemSelect" @padre:close="cerrarModalD")
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.is-size-3 Búsqueda de en Movimientos
              |
              a.button.is-black.is-rounded(@click="backToPage")
                i.fas.fa-times
            br
        .columns
          .column.is-4
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar por serie o modelo',
                  v-model="querie",
                )
          .column.is-2
            a.button.is-black(@click="buscarFac")
              | Buscar
      .container
        .columns
        .column.is-half.is-offset-one-quarter.has-text-centered
        .columns
          .table-responsive
            table#tbExistencias.table.is-striped.is-fullwidth
              thead
                tr
                  th Descripcion
                  th Resguardo
                  th Fecha de registro
                  th Ubicacion
                  th Factura
                  th Responsiva
                  th Imagen
              tbody
                tr(v-for="(data, index) in articulos", :key="data.id")
                  td
                    span.tag.is-light {{ data.descripcion }}
                    br
                    span.tag.is-light(v-show="data.serie.length > 0") Serie: {{ data.serie }}
                  td
                    span.tag(
                      :class="data.asignado.length > 0 ? 'is-success' : data.esSalida.length > 0 ? 'is-primary' : 'is-ligth'"
                    ) {{ data.resguardo }}
                    span &nbsp
                    a.button.is-rounded.is-small.is-danger(
                      v-show="data.asignacion.length > 0 || data.salida.length > 0",
                      @click="imprimirDocto(data)"
                    )
                      i.far.fa-file-pdf
                  td
                    span.tag.is-light {{ data.fechaCompra }}
                  td
                    span.tag.is-light {{ data.ubicacion }}
                  td
                    a.button.is-rounded.is-small.is-danger(
                      v-show="data.factura.length > 0",
                      :href="data.factura",
                      target="_blank"
                    )
                      span.icon
                        i.far.fa-file-pdf
                  td
                    a.button.is-light.is-rounded(v-show="data.id_responsiva !== ''" @click="downloadResponsiva(data)")
                      i.fas.fa-print
                      | &nbsp Responsiva
                  td
                    a.button.is-rounded.is-small(
                      @click="verModalD(data, 'images')",
                      :class="getClassTipo(data, '0')"
                    )
                      i.far.fa-folder-open
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import ModalDocumentosArt from './shared/ModalDocumentosArt.vue'
  import InventarioServices from '../../services/inventario/inventario'
  import { mapState } from 'vuex'
  export default {
    name: 'BusquedaAvanzada',
    components: {
      Loader, NavBarInventario, ModalDocumentosArt,
    },
    data() {
      return {
        isLoading: true,
        verArt: false,
        hayDatos: false,
        articulos: [],
        querie: '',
        buscarArtFac: false,
        itemSelect: {},
        modalStatusD: false,
        tipoFileUp: '',
        oficinas: [],
        almacenes: [],
        origen: {},
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerAlmacenes()
      },
      obtenerAlmacenes () {
        InventarioServices.getAlmacenesConsumibles('c')
          .then( data => {
            this.almacenes = data.map(this.convertirAlmacenes)
            this.obtenerAlmacenOrigen()
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },
      convertirAlmacenes (ofi) {
        return {
          ...ofi,
          id: parseInt(ofi.id),
          id_ubicacion: parseInt(ofi.id_ubicacion),
          id_oficina: parseInt(ofi.id_oficina),
          inventario: parseInt(ofi.inventario) == 1 ? true : false,
        }
      },
      obtenerAlmacenOrigen() {
        this.almacenes.map( alm => {
          const encontrado = alm.almacenistas.find( a => a.id_usuario === this.userLogin.id)
          if (encontrado) {
            this.origen = alm
          }
        })
        this.obtenerOficinas()
      },

      obtenerOficinas() {
        InventarioServices.getOficinas()
          .then( data => {
            this.oficinas = data.map(this.convertirOficinas)
            this.isLoading = false
          })
          .catch((e) => {
            this.isLoading = false
            console.log(`Error: ${e.message}`)
          })
      },

      convertirOficinas(ofi) {
        return {
          ...ofi,
          id: parseInt(ofi.id),
          oficina: ofi.nombre,
          id_ubicacion: parseInt(ofi.id_ubicacion),
          inventario: parseInt(ofi.inventario) == 1 ? true : false,
        }
      },

      buscarFac() {
        InventarioServices.getArticulosSerieModelo(this.querie)
        .then( data => {
          this.articulos = data       
        })
        .catch( e => {
          this.isLoading = false
          console.error(`Error: ${e.message}`)
        })
      },
      getClassTipo (item, tipo) {
        const { documentos } = item
        const typo = typeof documentos
        console.log(typo)
        if (typo === 'object') {
          console.log('Bien')
          const isFiles = documentos.some( d => d.tipo === tipo)
          return isFiles ? 'is-success' : 'is-warning'
        } else {
          console.log('mal')
          return 'is-warning'
        }
        
      },
      verModalD (data, tipo) {
        this.itemSelect = data
        this.modalStatusD = true
        this.tipoFileUp = tipo
      },
      cerrarModalD () {
        this.itemSelect = {}
        this.modalStatusD = false
      },
      imprimirDocto(data) {
        if (data.asignado.length > 0) {
          this.printAsignacion(data)
        } else {
          if (data.salida.length > 0) {
            this.printSalida(data)
          }
        }
      },

      printAsignacion(data) {
        const currentUrl = window.location.hostname
        const almacen = this.oficinas.find( ofi => ofi.clave === data.origen_ofi)
        const idAlm = almacen ? almacen.id_oficina : 0
        let link = `https://${currentUrl}/servidores/reportes/inventarios/asignacionI.php?idAsig=${data.asignacion[0].id}&alm=${idAlm}`
        if (!open(link)) {
          console.log('Error abriendo archivo')
        }
      },

      printSalida(data) {
        const currentUrl = window.location.hostname
        const almacen = this.oficinas.find( ofi => ofi.clave === data.origen_ofi)
        const idAlm = almacen ? almacen.id_oficina : 0
        const link = `https://${currentUrl}/servidores/reportes/inventarios/salidaI.php?id=${data.salida[0].id}&alm=${idAlm}`
        if (!open(link)) {
          console.log('Error')
        }
      },
      backToPage () {
        this.$router.back()
      },
      downloadResponsiva(articulo) {
        const currentUrl = window.location.hostname
        const link = `https://${currentUrl}/servidores/reportes/responsivas/responsiva_Multiple.php?id=${articulo.id_responsiva}&nombre=${articulo.responsiva}`
        window.open(link, '_blank')
      },
    },

    created () {
      this.iniciarComponente()
    },
    
  computed: {
    ...mapState(['userLogin'])
  },
  created () {

    this.iniciarComponente()
  },
  mounted() {
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.modalStatus = false // how to hide any open modal?
        this.modalStatusD = false
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inventario_Componentes/Buscar.vue